import { ArrowRightLeft, CheckCircle2, Clock, Scale } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCurrency } from "@/lib/utils";

interface Props {
  totalCount: number;
  completedCount: number;
  draftCount: number;
  /** Rupiah value of repack shrinkage — repacks mix units, so quantities don't add up. */
  totalShrinkageValue: number;
}

export function RepackingSummaryCards({
  totalCount,
  completedCount,
  draftCount,
  totalShrinkageValue,
}: Props) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Total Repacking
          </CardTitle>
          <ArrowRightLeft className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-muted-foreground" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold">{totalCount}</div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Dokumen pemecahan kemasan bulk
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Repacking Selesai
          </CardTitle>
          <CheckCircle2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-emerald-500" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-emerald-600 dark:text-emerald-400">
            {completedCount}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Stok dipindahkan ke wadah operasional
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Menunggu / Draft
          </CardTitle>
          <Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-amber-500" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-amber-600 dark:text-amber-400">
            {draftCount}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Draft belum dieksekusi ke kartu stok
          </p>
        </CardContent>
      </Card>

      <Card className="shadow-xs">
        <CardHeader className="flex flex-row items-center justify-between p-3 sm:p-6 pb-1 sm:pb-2">
          <CardTitle className="text-xs sm:text-sm font-medium text-muted-foreground line-clamp-1">
            Total Susut Proses
          </CardTitle>
          <Scale className="h-3.5 w-3.5 sm:h-4 sm:w-4 shrink-0 text-rose-500" />
        </CardHeader>
        <CardContent className="p-3 sm:p-6 pt-0 sm:pt-0">
          <div className="text-lg sm:text-2xl font-bold text-rose-600 dark:text-rose-400 truncate">
            {formatCurrency(totalShrinkageValue)}
          </div>
          <p className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-muted-foreground line-clamp-1">
            Nilai isi kemasan yang hilang saat dibuka
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
